import { byPrefixAndName } from "@awesome.me/kit-484d1df7c6/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { FunctionComponent } from "react";

interface CircleFullProps {
  color: "yellow" | "green" | "gray";
  className?: string;
}

export const CircleFull: FunctionComponent<CircleFullProps> = ({ color, className }) => {
  return (
    <FontAwesomeIcon
      icon={byPrefixAndName.fas["circle"]}
      className={`size-2 ${color === "yellow" ? "text-yellow-500" : color === "green" ? "text-green-500" : "text-gray-500"} ${className ? className : ""}`}
    />
  );
};
